// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDVmzzP1otUy77tkklftR9HRUEV_9zNb4E",
  authDomain: "hbb-beerlist.firebaseapp.com",
  databaseURL: "https://hbb-beerlist-default-rtdb.firebaseio.com",
  projectId: "hbb-beerlist",
  storageBucket: "hbb-beerlist.firebasestorage.app",
  messagingSenderId: "79650749872",
  appId: "1:79650749872:web:2042c63cbf879b9adaea75"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore

export { db }; // Make sure this export is present